import React, { FC, useEffect, useState } from 'react'
import Helmet from 'react-helmet'
import { useDispatch } from 'react-redux'
import EditModal from '../../../components/setting/record/EditModal'
import Tips from '../../../components/common/Tips'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Link, useParams } from 'react-router-dom'
import { setPath } from '../../../../utils/url'
import { LangValue } from '../../../../states/types/common'
import { URL } from '../../../constants/url'
import { fetchSettingWeeklyTrackTime, updateSettingWeeklyTrackTime } from '../../../../states/containers/setting/systemSlice'
import { RequestPatchSettingWeeklyTrackTime, SettingWeeklyTrackTimeMember } from '../../../../states/types/setting'
import { useAlert } from 'react-alert'
import LoadingSquare from '../../../components/common/LoadingSquare'

interface weeklyTrackTime {
  week_number: number
  track_start_time: string | null
  track_stop_time: string | null
}

interface RequestParams {
  commonFlg: boolean
  memberIds?: number[]
  changeAuthority?: boolean
  weeklyTrackTimes?: weeklyTrackTime[]
  useCommonSetting? : boolean
}

const Index: FC = () => {
  const dispatch = useDispatch()
  const alert = useAlert()
  const { language } = useParams<{ language: LangValue }>()

  const [memberDetail, setMemberDetail] = useState<SettingWeeklyTrackTimeMember>()
  const [exhibitWeeklyTrackTime, setExhibitWeeklyTrackTime] = useState<weeklyTrackTime[]>([])

  const [commonValue, setCommonValue] = useState<weeklyTrackTime[]>([])

  const [isDisplayModal, setIsDisplayModal] = useState<boolean>(false)

  const [isLoading, setIsLoading] = useState<boolean>(true)

  const openModal = () => {
    setIsDisplayModal(true)
  }

  const closeModal = () => {
    setIsDisplayModal(false)
  }

  const changeWeeklyTrackTime = (data: RequestParams) => {
    const param: RequestPatchSettingWeeklyTrackTime = {
      change_common_setting: false,
      member_ids: data.memberIds,
      use_common_setting: data.useCommonSetting,
    }
    if (!data.useCommonSetting) param.weekly_track_times = data.weeklyTrackTimes
    dispatch(updateSettingWeeklyTrackTime(
      param,
      () => {
        closeModal()
        if (memberDetail) {
          setMemberDetail({
            ...memberDetail,
            weekly_track_times: param.weekly_track_times || commonValue,
            use_common_setting: param.use_common_setting || false,
          })
        }
        if (data.useCommonSetting) {
          setExhibitWeeklyTrackTime(commonValue)
        } else {
          setExhibitWeeklyTrackTime(param.weekly_track_times || commonValue)
        }
        alert.success("ユーザーの設定を変更しました")
      },
    ))
  }

  const displayTime = (value: {week_number: number, track_start_time: string | null, track_stop_time: string | null}) => {
    if ((value.track_start_time === value.track_stop_time) && (value.track_start_time !== null && value.track_stop_time !== null)) {
      return (
        <div
          style={{
            display: "flex",
            flexFlow: "column",
            gap: "2px",
            color: "#FF0000",
          }}
        >
          <Tips
            description="計測しない"
            className=""
            icon={false}
          >
            <div style={{ fontSize: "16px" }}>
              <FontAwesomeIcon icon={['fas', 'times']} />
            </div>
          </Tips>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              gap: "2px",
            }}
          >
            計測しない
          </div>
        </div>
      )
    }
    if ((value.track_start_time === null) && (value.track_stop_time === null)) {
      return (
        <div
          style={{
            display: "flex",
            flexFlow: "column",
            gap: "2px",
            color: "#0f9655",
          }}
        >
          <Tips
            description="終日計測する"
            className=""
            icon={false}
          >
            <div style={{ fontSize: "16px" }}>
              <FontAwesomeIcon icon={['fas', 'play-circle']} />
            </div>
          </Tips>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              gap: "2px",
            }}
          >
            <div>
              0:00
            </div>
            <div>
              ~
            </div>
            <div>
              24:00
            </div>
          </div>
        </div>
      )
    }
    return (
      <div
        style={{
          display: "flex",
          flexFlow: "column",
          gap: "2px",
          color: "#666666",
        }}
      >
        <Tips
          description="計測制限あり"
          className=""
          icon={false}
        >
          <div style={{ fontSize: "16px" }}>
            <FontAwesomeIcon icon={['far', 'clock']} />
          </div>
        </Tips>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            gap: "2px",
          }}
        >
          <div>
            {value.track_start_time ? value.track_start_time.substring(0, 5) : "0:00"}
          </div>
          <div>
            ~
          </div>
          <div>
            {value.track_stop_time ? value.track_stop_time.substring(0, 5) : "24:00"}
          </div>
        </div>
      </div>
    )
  }

  const legend = (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        gap: "8px",
        padding: "8px 16px",
        border: "solid 1px #CCCCCC",
        backgroundColor: "#FAFAFA",
        marginBottom: "8px",
      }}
    >
      <div
        style={{
          fontWeight: "bold",
          color: "#666666",
        }}
      >
        凡例
      </div>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "right",
          gap: "8px",
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "2px",
            fontSize: "11px",
          }}
        >
          <div style={{ color: "#0f9655" }}>
            <FontAwesomeIcon icon={['fas', 'play-circle']} />
          </div>
          <div>
            :
          </div>
          終日計測する
        </div>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "2px",
            fontSize: "11px",
          }}
        >
          <div style={{ color: "#FF0000" }}>
            <FontAwesomeIcon icon={['fas', 'times']} />
          </div>
          <div>
            :
          </div>
          計測しない
        </div>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "2px",
            fontSize: "11px",
          }}
        >
          <div style={{ color: "#777777" }}>
            <FontAwesomeIcon icon={['far', 'clock']} />
          </div>
          <div>
            :
          </div>
          計測制限あり
        </div>
      </div>
    </div>
  )

  useEffect(() => {
    setIsLoading(true)
    dispatch(
      fetchSettingWeeklyTrackTime(
        { only_oneself: true },
        (result) => {
          setCommonValue(result.common.weekly_track_times)
          setMemberDetail(result.members[0])
          if (result.members[0].use_common_setting) {
            setExhibitWeeklyTrackTime(result.common.weekly_track_times)
          } else {
            setExhibitWeeklyTrackTime(result.members[0].weekly_track_times)
          }
          setIsLoading(false)
        },
      ),
    )
  }, [])

  return (
    <section className="setting_page">
      <Helmet>
        <title>Qasee - 設定 - 個人設定 - 計測時間設定</title>
      </Helmet>
      <section className="breadcrumb">
        設定
        &nbsp;&gt;&nbsp;
        <Link
          to={setPath(URL.SETTING_PERSONAL.path, language)}
        >
          個人設定
        </Link>
        &nbsp;&gt;&nbsp;
        計測時間設定
        &nbsp;
      </section>
      <section className="page_header">
        <h1>計測時間設定</h1>
      </section>
      <section className="page_description">
        <p>
          Qaseeで計測する時間を設定することができます。
        </p>
        <p>
          指定した時間内のみ計測を行います。
        </p>
      </section>
      {
        isLoading ? (
          <LoadingSquare>
            <>
              設定を読み込んでいます…
            </>
          </LoadingSquare>
        ) : (
          <>
            <section className="page_contents content-area">
              <div className="content-block">
                <div className="block-detail">
                  <div className="header_area measurement">
                    <div className="title">あなたの計測時間</div>
                    {
                      memberDetail?.change_authority ? (
                        <button
                          type="button"
                          className="edit_button"
                          onClick={openModal}
                        >
                          計測時間設定を編集する
                        </button>
                      ) : (
                        <Tips
                          description="権限がありません"
                          className=""
                          icon={false}
                        >
                          <button
                            type="button"
                            className="edit_button checked"
                          >
                            計測時間設定を編集する
                          </button>
                        </Tips>
                      )
                    }
                  </div>
                  {legend}
                  <table className="company_track_table">
                    <thead>
                      <tr>
                        <th style={{ color: "#FF0000" }}>日曜日</th>
                        <th>月曜日</th>
                        <th>火曜日</th>
                        <th>水曜日</th>
                        <th>木曜日</th>
                        <th>金曜日</th>
                        <th style={{ color: "#317AB7" }}>土曜日</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        {
                          exhibitWeeklyTrackTime && exhibitWeeklyTrackTime.map((v) => (
                            <td key={v.week_number}>
                              {displayTime(v)}
                            </td>
                          ))
                        }
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <EditModal
                targetMemberList={memberDetail ? [memberDetail] : []}
                commonValues={commonValue}
                isDisplayModal={isDisplayModal}
                modalType="single"
                submitCallback={(data: RequestParams) => changeWeeklyTrackTime(data)}
                closeCallback={closeModal}
              />
            </section>
          </>
        )
      }
    </section>
  )
}

export default Index
